import { render, staticRenderFns } from "./BreadcrumbsBar.vue?vue&type=template&id=510905d3&"
import script from "./BreadcrumbsBar.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsBar.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbsBar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510905d3')) {
      api.createRecord('510905d3', component.options)
    } else {
      api.reload('510905d3', component.options)
    }
    module.hot.accept("./BreadcrumbsBar.vue?vue&type=template&id=510905d3&", function () {
      api.rerender('510905d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BreadcrumbsBar.vue"
export default component.exports